import { bunja } from 'bunja';
import { useBunja } from 'bunja/react';
import { useAtom } from 'jotai';

import { T } from '@flipster/i18n';
import { Checkbox } from '@flipster/react/design-system/checkbox';
import { css } from '@flipster/styled-system/css';
import { hstack, stack } from '@flipster/styled-system/patterns';

import { tpslModalInputBunja } from '../../state';
import { LimitPriceInput } from './limit-price-input';

export const SetLimitPriceSection = () => {
  const { isBboAtom } = useBunja(setLimitPriceSectionBunja);
  const [isBbo, setIsBbo] = useAtom(isBboAtom);

  return (
    <section className={stack({ gap: 8 })}>
      <div className={hstack({ justify: 'space-between', alignItems: 'center' })}>
        <p className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-5' })}>
          <T id='Trade.r260420.Limit_price' />
        </p>
        <Checkbox checked={isBbo} onChange={(e) => setIsBbo(e.target.checked)}>
          <span className={css({ textStyle: 'Body/M/Regular', color: 'content.default.level-5' })}>
            <T id='Autogen_common.r251126.s_BBO' />
          </span>
        </Checkbox>
      </div>
      {isBbo ? (
        <div
          className={css({
            h: 48,
            px: 12,
            rounded: 8,
            border: '1px solid',
            borderColor: 'border.default.level-1',
            bg: 'background.default.level-1',
            display: 'flex',
            alignItems: 'center',
            textStyle: 'Body/XL/Monospace/Regular',
            color: 'content.default.level-3',
          })}
        >
          <T id='Trade.r260420.Best_counterparty' />
        </div>
      ) : (
        <LimitPriceInput />
      )}
    </section>
  );
};

const setLimitPriceSectionBunja = bunja(() => {
  const { isBboAtom } = bunja.use(tpslModalInputBunja);
  return { isBboAtom };
});
setLimitPriceSectionBunja.debugLabel = 'setLimitPriceSectionBunja';
